/**
 * Created by filatov on 17.09.2015.
 */
import CostCSVPreviewBaseColumnsStrategy from './CostCSVPreviewBaseColumnsStrategy'

export default function CostCSVPreviewUserByGroupsThreeLevels() {}

CostCSVPreviewUserByGroupsThreeLevels.prototype = new CostCSVPreviewBaseColumnsStrategy();

CostCSVPreviewUserByGroupsThreeLevels.prototype.init = function ({showSpentTime, showAverageRates, showUserRates, showSubtotalsByDepartments, showOthers})
{
    CostCSVPreviewBaseColumnsStrategy.prototype.init.call( this, showSpentTime, showAverageRates);
    this.showUserRates =  showUserRates;
    this.showSubtotalsByDepartments = showSubtotalsByDepartments;
    this.showOthers = showOthers
    return this;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.getNumOfDetailsColumns = function() {
    let numOfDetailsColumns = this._getNumOfSubtotalDetailsColumns() + this._getNumOfUserDetailsColumns()
    if (this.showOthers) numOfDetailsColumns += this._getNumOfUserDetailsColumns()
    return numOfDetailsColumns
}

CostCSVPreviewUserByGroupsThreeLevels.prototype._getNumOfUserDetailsColumns = function(){
    var countText = 1;
    if( this.showSpentTime )
        countText ++;
    if( this.showUserRates )
        countText ++;
    return countText;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype._getNumOfSubtotalDetailsColumns = function() {
    var countText = 0;
    if ( this.showSubtotalsByDepartments ){
        countText++;

        if ( this.showSpentTime){
            countText++;
        }
    }
    return countText;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.addThirdHeaderRowDataCells = function(row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount())
    const numOfUserDetailsSubColumns = this._getNumOfUserDetailsColumns()
    const numOfGropingHeadersColumns = numOfUserDetailsSubColumns + this._getNumOfSubtotalDetailsColumns()
    for (let i = 0; i < numOfGropingHeadersColumns; i++) {
        this.addCell(row, this.message("user.group"))
    }
    if (this.showOthers) ReportPreviewUtils.addEmptyCells(row, numOfUserDetailsSubColumns)
}

CostCSVPreviewUserByGroupsThreeLevels.prototype.addSecondHeaderRowDataCells = function(row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount())
    const countUserColumns = this._getNumOfUserDetailsColumns()
    const countSubtotalColumns = this._getNumOfSubtotalDetailsColumns()
    for (let i = 0; i < countSubtotalColumns; i++) {
        this.addCell(row, this.message("report.subtotal"))
    }
    for (let i = 0; i < countUserColumns; i++) {
        this.addCell(row, this.message("report.user"))
    }
    if (this.showOthers) {
        for (let i = 0; i < countUserColumns; i++) {
            this.addCell(row, this.message("report.common.others"))
        }
    }
}

CostCSVPreviewUserByGroupsThreeLevels.prototype.addFirstHeaderRowDataCells = function(row) {
    this.addOverallHeaderCells(row)
    if (this.showSubtotalsByDepartments) {
        if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"), "spent")
        this.addCell(row, this.message("report.cost.cost"), "cost")
    }
    this._addFirstHeaderRowUserDataCells(row)
    if (this.showOthers) this._addFirstHeaderRowUserDataCells(row)
}

CostCSVPreviewUserByGroupsThreeLevels.prototype._addFirstHeaderRowUserDataCells = function ( row ) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"), "spent")
    if (this.showUserRates) this.addCell(row, this.message("report.cost.rate"), "rate")
    this.addCell(row, this.message("report.cost.cost"), "cost")
}

CostCSVPreviewUserByGroupsThreeLevels.prototype.getCountGroupingRows = function ( colGroupingRow )
{
    return 3;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewUserByGroupsThreeLevels.js